import { graphql } from '@api/gql';

export const inventoryCountsDocument = graphql(/* GraphQL */ `
  query InventoryCounts($filter: InventoryFilterInput!) {
    inventoryCounts(filter: $filter) {
      resourcesCount
      permissionsCount
      entitlementsCount
    }
  }
`);
